
const wstActivationMainRoutes = Array.from({ length:14}, (_, i) => ({
  path: `activation/wst/index${i + 1}`,
  name: `activationWstIndex${i + 1}`,
  component: () => import(`@/views/health/activation/wst/index${i + 1}.vue`),
}));


export default {
  path: "/health",
  component: { render: (c) => c("router-view") },
  children: [
    // 预约挂号——皖事通，主流程
    ...wstActivationMainRoutes,
  ],
};
